import formActions from 'redux-form/lib/actions'

import {call, put, select, take, takeLatest} from 'redux-saga/effects'

import history from '../history'
import {REDUX} from '../const'

import {login, LOGIN_SUCCESS} from '../actions/api'
import {onStatus} from '../api/helpers'
import {SHOW_PASSWORD_RESET_REQUEST_FORM} from '../actions/userInteractions'
import * as URLS from '../urls'
import * as user from '../store/user'
import * as userActions from '../actions/user'
import * as userApi from '../api/user'

// Get User Account Balance
// ----------------------------------------------------------------------------

export function* getAccountBalanceWorker() {
  yield put(userActions.getAccountBalancePending())
  const userId = yield select(user.id)
  try {
    const response = yield call(userApi.getAccountBalance, userId)
    const result = onStatus({
      OK: ({json}) => json,
      DEFAULT: () => {
        throw new Error('Unable to fetch account balance')
      },
    })(response)
    yield put(userActions.getAccountBalanceSuccess(result))
  } catch (err) {
    yield put(userActions.getAccountBalanceFailure(err))
  }
}

export function* getAccountBalanceSaga() {
  yield takeLatest(userActions.GET_ACCOUNT_BALANCE, getAccountBalanceWorker)
}

// Reset User Password
// ----------------------------------------------------------------------------

function* resetUserPasswordWorker({payload}) {
  try {
    const {email} = yield userApi.resetUserPassword(payload).then(
      onStatus({
        OK: ({json}) => json,
        DEFAULT: ({statusText}) => {
          throw new Error(`Could not reset user password: ${statusText}`)
        },
      }),
    )

    yield put(userActions.resetUserPasswordSuccess())

    // Auto-login user on reset password success and redirect to homepage
    yield put(login(email, 'Reset Password', payload.password))
    yield take(LOGIN_SUCCESS)
    window.location.href = URLS.HOME
  } catch (e) {
    console.error(e)
    yield put(userActions.resetUserPasswordFailure())
    yield put(
      formActions.stopSubmit('AccountPasswordResetForm', {
        password: 'An unexpected error occured. Please try again or refresh the page.',
        passwordConfirmation: ' ',
      }),
    )
  }
}

export function* resetUserPasswordSaga() {
  yield takeLatest(userActions.RESET_USER_PASSWORD, resetUserPasswordWorker)
}

// Update User Info
// ----------------------------------------------------------------------------

function* updateUserInfoWorker({payload}) {
  try {
    const state = yield select()
    const userId = user.id(state)
    const version = user.version(state)
    const newPayload = {...payload, ...{version}}
    const userInfoJson = yield userApi.updateUserInfo(userId, newPayload).then(
      onStatus({
        OK: ({json}) => json,
        DEFAULT: ({statusText}) => {
          throw new Error(`Could not update user info: ${statusText}`)
        },
      }),
    )
    yield put(userActions.updateUserInfoSuccess(userInfoJson))
  } catch (e) {
    console.error(e)
    yield put(userActions.updateUserInfoFailure())
    yield put(
      formActions.stopSubmit(REDUX.ACCOUNT_INFO_USER_FORM, {
        email: 'An unexpected error occurred. Please try again or refresh the page.',
        firstName: ' ',
        lastName: ' ',
      }),
    )
  }
}

export function* updateUserInfoSaga() {
  yield takeLatest(userActions.UPDATE_USER_INFO, updateUserInfoWorker)
}

// Update User Password
// ----------------------------------------------------------------------------

function* updateUserPasswordWorker({payload}) {
  try {
    yield userApi.updateUserPassword(payload).then(
      onStatus({
        OK: ({json}) => json,
        DEFAULT: ({statusText}) => {
          throw new Error(`Could not update user password: ${statusText}`)
        },
      }),
    )

    yield put(userActions.updateUserPasswordSuccess())
  } catch (e) {
    console.error(e)
    yield put(userActions.updateUserPasswordFailure())
    yield put(
      formActions.stopSubmit(REDUX.ACCOUNT_INFO_PASSWORD_FORM, {
        password: 'An unexpected error occurred. Please try again or refresh the page.',
        passwordConfirmation: ' ',
      }),
    )
  }
}

export function* updateUserPasswordSaga() {
  yield takeLatest(userActions.UPDATE_USER_PASSWORD, updateUserPasswordWorker)
}

// Load Password Reset Request Form
// ----------------------------------------------------------------------------

function loadPasswordRequestSectionWorker() {
  history.push(URLS.RESET_PASSWORD)
}

export function* loadPasswordResetSectionSaga() {
  yield takeLatest(SHOW_PASSWORD_RESET_REQUEST_FORM, loadPasswordRequestSectionWorker)
}
